import { useEffect, useState } from "react";
import app from "./app";

let editor = null;

export default function JSONEditor(props) {
    const [text, setText] = useState("");
    useEffect(() => {
        //document.querySelector("#jsoneditor").innerText = props.text;
        app.loadScript("https://cdnjs.cloudflare.com/ajax/libs/ace/1.31.1/ace.min.js", "ace").then(function(){
            
            editor = window.ace.edit("jsoneditor", {
                mode: 'ace/mode/json',
                selectionStyle: 'text',
                showPrintMargin: false,
                theme: 'ace/theme/chrome'
            });
            editor.setValue(props.text);
            editor.on('paste', (event) => {
                try {
                    event.text = JSON.stringify(JSON.parse(event.text), null, 4)
                } catch (err) {
                    // meh
                }
            })
            editor.on('change', (event) => {
                props.callback(editor.getValue());
            })
        })

        //props.callback(formatText(4));
    }, [])

    const formatText = (spacing = 0) => {
        try {
            if(editor) {
                const current = JSON.parse(editor.getValue())
                editor.setValue(JSON.stringify(current, null, spacing))
                editor.focus()
                editor.selectAll()
                document.execCommand('copy')
            }
            else {
                console.log('ERROR: Unable to parse text as JSON')
            }
        } catch (err) {
            console.log('ERROR: Unable to parse text as JSON')
        }
    }

    return <div id="jsoneditor" className="w-100 h-100"  />
}